

/**
 * replaceBanCharFileName
 * ファイ名禁止文字の変換
 * @param str ターゲット
 * @param replaceChar 変換文字
 * @param parcentOn パーセントを禁止にするか。置換文字列用
 * @returns 変換されたターゲット
 */
export const replaceBanCharFileName = (str: string, replaceChar: string, parcentOn=true) => {

	// Winファイル名禁止 " < > | : * ? \ /
	// コマンド禁止 & ( ) [ ] { } ^ = ; ! ' + , ` ~
	// OneDrive禁止 ~ # % & { | } .
	// win禁止予約語　AUX CLOCK$ COM0 ～ COM9 CON LPT0 ～ LPT9 NUL PRN
	// " < > | : * ? \ / & # % ( ) [ ] { } ^ = ; ! ' + , ` ~

	const winFileBanChar = /"|<|>|\||:|\*|\?|\\|\//g;
	const windComBanChar = /\&|\(|\)|\[|\]|\{|\}|\^|\=|;|\!|\'|\+|\,|\`|\~/g;
	const oneDriveBanChar = /\~|\#|\%|\&|\{|\||\}|\./g;
	const winBanWordChar = /AUX|CLOCK\$|COM[0-9]|CON|LPT[0-9]|NUL|PRN/g;

	str = str.replace(winFileBanChar, replaceChar);
	str = str.replace(windComBanChar, replaceChar);
	str = parcentOn ? str.replace(oneDriveBanChar, replaceChar) : str;
	str = str.replace(winBanWordChar, replaceChar);

	return str.trim();
};

/**
 * 全角文字チェック
 * @param str ターゲット
 * @param replaceChar 置換したい時いれる
 * @returns boolean | string
 */
export const checkFullWidthString = (str: string, replaceChar='' ) => {

	const fullWidthString =  /[^\x00-\x7E]+/g;

	if(replaceChar) {
		return str.replace(fullWidthString, replaceChar);
	} else {
		return str.match(fullWidthString);
	}

};

/**
 * （漢字）名前用正規表現（々、ゞなど込み）
 *
 * unicode (hex)
 * 々-〇 3005-3007 https://en.wikipedia.org/wiki/List_of_Unicode_characters#CJK_Symbols_and_Punctuation
 * ぁ-ゖ 3041-3096 https://en.wikipedia.org/wiki/List_of_Unicode_characters#Hiragana
 * ゙-ゟ 3099-309f https://en.wikipedia.org/wiki/List_of_Unicode_characters#Hiragana
 * ァ-ヿ 30a1-30ff https://en.wikipedia.org/wiki/List_of_Unicode_characters#Katakana
 * 一-鿿 4e00-9fff https://en.wikipedia.org/wiki/CJK_Unified_Ideographs_(Unicode_block)
 *
 * CJK 統合漢字拡張A (https://en.wikipedia.org/wiki/CJK_Unified_Ideographs#CJK_Unified_Ideographs_Extension_A)
 * 以降を追加する必要があるかも
 */
export const patternForName = "^[々-〇ぁ-ゖ゙-ゟァ-ヿ一-鿿a-zA-ZＡ️-Ｚー]+$"
export const regExpForName = new RegExp(patternForName)

/**
 * （カナ）名前用正規表現（ー、ヽ、ヾ込み）
 *
 * ァ-ヿ 30a1-30ff https://en.wikipedia.org/wiki/List_of_Unicode_characters#Katakana
 */
export const patternForKana = "^[ァ-ヿ]+$"
export const regExpForKana = new RegExp(patternForKana)

/**
 * 郵便番号正規表現(ハイフン無し)
 */
export const patternForPostCode = '^[0-9]{7}$';
export const regExpForPost = new RegExp(patternForPostCode);
